import request from '@/utils/request';

//查询货架列表
export function getQueryShelfList(param) {
  return request('/activityPoints/queryShelfList', {
    method: 'POST',
    data: param,
  });
}

//删除货架
export const deleteShelf = (data) => {
  return request('/activityPoints/deleteShelf', {
    method: 'POST',
    data,
  });
};

//校验删除货架
export const canDeleteGoodsShelf = (data) => {
  return request('/activityPoints/queryGiftExchange', {
    method: 'POST',
    data,
  });
};

//导出货架数据明细报表
export const exportShelfItemData = (data) => {
  return request('/activityPoints/exportShelfItemData', {
    method: 'POST',
    data,
  });
};

//导出货架数据汇总报表
export const exportShelfSummaryData = (data) => {
  return request('/activityPoints/exportShelfSummaryData', {
    method: 'POST',
    data,
  });
};
